var fails = {
    structuralGrade: 0,
    claddingGrade: 0,
    deflection: 0,
    centers: 0,
    cosmetic: 0
}


function beginNow() {
    $("#landingPanel").hide();
    $("#shedHealthTest").show();
    displayStep(2);
}


function displayElement(elementId) {
    var element = $("#" + elementId);
    element.show();
    if (elementId === 'purlinCalculator') {
        $("#purlinCalcButton").html("Hide Calculator");
    }
}


// noinspection JSUnusedGlobalSymbols
function displayStep(step) {

    var requestedStep = parseInt(step);
    var backButton = $("#backButton");
    var nextButton = $("#nextButton");
    var progressBar = $("#progressBar");
    var restartButton = $("#restartButton");
    var element;
    var elementTab;
    var goTo;
    var questions;
    var questionsAnswered;
    var steps;
    var myInt;

    steps = [];
    steps.push(1);
    steps.push(2);
    steps.push(3);
    steps.push(4);
    steps.push(5);
    steps.push(6);

    $.each(steps, function (index, value) {
        element = $("#step" + value);
        elementTab = $("#step" + value + "Tab");

        // Make Sure Questions Answered before Proceeding
        goTo = null;
        if (requestedStep === 3) {
            questions = ['portalHiTensile', 'rafterDeflection'];
            questionsAnswered = 0;
            $.each(questions, function (index, value) {
                if ($("#" + value).prop('checked') || $("#" + value + "Fail").prop('checked')) {
                    questionsAnswered++;
                } else {
                    goTo = value;
                    return false;
                }
            });
        } else if (requestedStep === 4) {
            questions = ['purlinHiTensile', 'purlinDeflection', 'purlinCenters'];
            questionsAnswered = 0;
            $.each(questions, function (index, value) {
                if ($("#" + value).prop('checked') || $("#" + value + "Fail").prop('checked')) {
                    questionsAnswered++;
                } else {
                    goTo = value;
                    return false;
                }
            });
        } else if (requestedStep === 5) {
            questions = ['girtHiTensile', 'girtCenters'];
            questionsAnswered = 0;
            $.each(questions, function (index, value) {
                if ($("#" + value).prop('checked') || $("#" + value + "Fail").prop('checked')) {
                    questionsAnswered++;
                } else {
                    goTo = value;
                    return false;
                }
            });
        } else if (requestedStep === 6) {
            questions = ['claddingRoofHiTensile', 'claddingRoofGauge', 'claddingRoofColour'];
            questionsAnswered = 0;
            $.each(questions, function (index, value) {
                if (value === 'claddingRoofColour') {
                    if ($("#" + value).val() !== null) {
                        questionsAnswered++;
                    } else {
                        goTo = value;
                        return false;
                    }
                } else if ($("#" + value).prop('checked') || $("#" + value + "Fail").prop('checked')) {
                    questionsAnswered++;
                } else {
                    goTo = value;
                    return false;
                }
            });
        }

        if (goTo) {
            scrollTo(goTo + "Question");
            $("#" + goTo + "AnswerRequired").show();
        } else {
            if (value !== requestedStep) {
                if (elementTab.hasClass("active")) {
                    elementTab.removeClass("active");
                }
                element.hide();
            } else {
                if (!elementTab.hasClass("active")) {
                    elementTab.addClass("active");
                }
                element.show();
            }
            myInt = requestedStep - 1 < 1 ? 1 : requestedStep - 1;
            if (requestedStep === 2) {
                backButton
                    .attr('onclick', 'restartTest()')
                    .show();
            } else {
                backButton
                    .attr('onclick', 'displayStep(' + myInt + ')')
                    .show();
            }
            myInt = requestedStep + 1 > 6 ? 6 : requestedStep + 1;
            if (requestedStep === 6) {
                nextButton.hide();
                restartButton.show();
            } else {
                restartButton.hide();
                nextButton
                    .attr('onclick', 'displayStep(' + myInt + ')')
                    .show();
            }
        }
    });

    if (!goTo) {
        if (requestedStep > 1) {
            progressBar.show();
        } else {
            progressBar.hide();
        }

        if (requestedStep === 6) {
            resultsPage();
        }

        $([document.documentElement, document.body]).animate({
            scrollTop: $("#step" + requestedStep + "Top").offset().top - 12
        }, 1000);
    }

}


function calculateStars() {

    var element;
    var elements;
    var elementAnswerRequired;
    var elementSuccess;
    var elementWarning;
    var failElement;
    var myHTML;

    elements = [];
    elements.push("portalHiTensile");
    elements.push("rafterDeflection");
    elements.push("purlinHiTensile");
    elements.push("purlinDeflection");
    elements.push("purlinCenters");
    elements.push("girtHiTensile");
    elements.push("girtCenters");
    elements.push("claddingRoofHiTensile");
    elements.push("claddingRoofGauge");
    elements.push("claddingRoofColour");

    var score = 0;
    var count = 0;
    fails.structuralGrade = 0;
    fails.claddingGrade = 0;
    fails.deflection = 0;
    fails.centers = 0;
    fails.cosmetic = 0;

    $.each(elements, function (index, value) {
        element = $("#" + value);
        elementAnswerRequired = $("#" + value + "AnswerRequired");
        elementSuccess = $("#" + value + "Success");
        elementWarning = $("#" + value + "Warning");
        if (value === "claddingRoofColour") {
            if (element.val() === "fail") {
                elementAnswerRequired.hide();
                elementSuccess.hide();
                elementWarning.show();
                fails.cosmetic++;
            } else if (element.val() !== "fail" && element.val() !== "incomplete" && element.val() !== null) {
                score++;
                elementAnswerRequired.hide();
                elementSuccess.show();
                elementWarning.hide();
            }
            count++;
        } else {
            failElement = $("#" + value + "Fail");
            if (element.prop('checked')) {
                score++;
                elementAnswerRequired.hide();
                elementSuccess.show();
                elementWarning.hide();
            } else if (!element.prop('checked') &&
                failElement.prop('checked')) {
                elementAnswerRequired.hide();
                elementSuccess.hide();
                elementWarning.show();
                if (value === "portalHiTensile" ||
                    value === "purlinHiTensile" ||
                    value === "girtHiTensile") {
                    fails.structuralGrade++;
                } else if (value === "claddingRoofHiTensile" ||
                    value === "claddingRoofGauge") {
                    fails.claddingGrade++;
                } else if (value === "rafterDeflection" || value === "purlinDeflection") {
                    fails.deflection++;
                } else if (value === "purlinCenters" || value === "girtCenters") {
                    fails.centers++
                }
            } else {
                elementSuccess.hide();
                elementWarning.hide();
            }
            count++;
        }
    });

    var progressBarSlider = $("#progressBarSlider");
    var progressBarSliderColour = 'rgb(0,160,0)';

    // Treat the score if there are structural or quality concerns
    if (fails.centers + fails.deflection > 0) {
        score *= 0.65;
        progressBarSliderColour = 'rgb(255,0,0)';
    } else if (fails.structuralGrade > 0) {
        score *= 0.75;
        progressBarSliderColour = 'rgb(255,69,0)';
    } else if (fails.claddingGrade > 0) {
        score *= 0.85;
        progressBarSliderColour = 'rgb(255,140,0)';
    } else if (fails.cosmetic > 0) {
        score *= 0.95;
        progressBarSliderColour = 'rgb(255,165,0)';
    }

    var progressBarHTML = $("#progressBarHTML");
    var progressBarPercentage = (score/count) * 100;
    var progressBarPercentageText;
    var progressBarStarsScore;
    var progressBarStarsTotal = 5;
    var stars;

    progressBarPercentageText  = progressBarPercentage.toFixed(0);
    progressBarPercentageText += "%";
    progressBarSlider.css('background-color', progressBarSliderColour).css('width', progressBarPercentageText);

    progressBarStarsScore = progressBarStarsTotal * (score/count);
    stars = progressBarStarsScore.toFixed(1);
    if (stars.substr(stars.length - 2) === '.0') {
        stars = progressBarStarsScore.toFixed(0);
    }
    myHTML  = '<i class="fe-icon-activity ml-2 font-weight-bold text-shadow pr-2"></i>';
    myHTML += 'Shed Health: ';
    myHTML += stars;
    myHTML += ' / ' + progressBarStarsTotal;
    progressBarHTML.html(myHTML);

    updateTabs();

}


function manageList(listDetails, instruction) {
    var details = listDetails.split('_'); // 'Q1_4'
    var element;
    var expand = instruction === 'expand';
    var loop = 1;
    var loopEnd = parseInt(details[1]);
    var onclick;
    var icon, iconHTML;
    while (loop <= loopEnd) {
        element = $("#" + details[0] + "_" + loop);
        icon = $("#" + details[0] + "_icon");
        if (expand) {
            onclick = "manageList('" + listDetails + "', 'collapse');";
            element.attr('onclick', onclick).show();
            if (loop === 1) {
                iconHTML = '<i class="fe-icon-minus"></i>';
                icon.html(iconHTML);
            }
        } else {
            onclick = "manageList('" + listDetails + "', 'expand');";
            element.attr('onclick', onclick);
            if (loop === 1) {
                iconHTML = '<i class="fe-icon-plus"></i>';
                icon.html(iconHTML);
            } else {
                element.hide();
            }
        }
        loop++;
    }
}


// noinspection JSUnusedGlobalSymbols
function radioMe(changedId, groupIds) {
    var group = groupIds.split("~");
    $.each(group, function (index, value) {
        if (value !== changedId) {
            $("#" + value).prop('checked', false);
        }
    });
    calculateStars();
}


function getPurlinFields() {
    var fields = [];
    fields.push(["purlinCalcTopHat", "TH6175"]);
    fields.push(["purlinCalcRegion", "A"]);
    fields.push(["purlinCalcTerrain", "2.5"]);
    fields.push(["purlinCalcShielding", "No"]);
    fields.push(["purlinCalcBaySize", 2500]);
    fields.push(["purlinCalcCenters", 600]);
    fields.push(["purlinCalcCentersMax", "616 mm"]);
    fields.push(["purlinCalcDeflectionActual", "8.1 mm"]);
    fields.push(["purlinCalcDeflectionAllowable", "8.3 mm"]);
    return fields;
}


function resetPurlinFields() {
    var myEl;
    var fields = getPurlinFields();
    $.each(fields, function (index, field) {
        myEl = $("#" + field[0]);
        myEl.val(field[1]);
        if (field[0] === "purlinCalcCentersMax" || field[0] === "purlinCalcDeflectionActual" || field[0] === "purlinCalcDeflectionAllowable") {
            myEl.css('color', 'rgb(64, 64, 64)');
            myEl.css('background-color', 'rgb(245, 245, 245)');
            myEl.css('border-color', 'rgb(228, 228, 228)');
            myEl.css('font-weight', 'normal');
        }
    });
    $("#purlinCalcWarningBottom").hide();
    $("#purlinCalcWarningTop").hide();
    purlinCalcPreset(2500, 'no');
}


function purlinCalcPreset(baySizeInput, runPurlinCalc) {
    var baySize = parseInt(baySizeInput);
    if (baySize === 2500) {
        $("#purlinCalcPreset25m").prop('checked',true);
    } else if (baySize === 3000) {
        $("#purlinCalcPreset30m").prop('checked',true);
    } else if (baySize === 3500) {
        $("#purlinCalcPreset35m").prop('checked',true);
    } else if (baySize === 4000) {
        $("#purlinCalcPreset40m").prop('checked',true);
    } else {
        $("#purlinCalcPresetCustom").prop('checked',true);
    }
    if (runPurlinCalc === 'yes') {
        $("#purlinCalcBaySize").val(baySize);
        purlinCalcResult();
    }
}


// noinspection JSUnusedGlobalSymbols
function purlinCalcResult() {

    validatePurlinShielding();

    var result;
    var resultRounded;
    var resultFixed;

    var ix;
    var windPressure;
    var windSpeed;

    // Input
    var baySizeEl = $("#purlinCalcBaySize");
    var baySize = baySizeEl.val();
    if (isNaN(baySize)) {
        baySize = 2500;
        baySizeEl.val(baySize);
    }
    var purlinCentersActualEl = $("#purlinCalcCenters");
    var purlinCentersActual = parseInt(purlinCentersActualEl.val());
    if (isNaN(purlinCentersActual)) {
        purlinCentersActual = 600;
        purlinCentersActualEl.val(purlinCentersActual);
    }

    var region = $("#purlinCalcRegion").val();
    var shielding = $("#purlinCalcShielding").val();
    var terrainCategory = $("#purlinCalcTerrain").val();
    var topHat = $("#purlinCalcTopHat").val();

    // Output Values
    var deflectionAllowed;
    var deflectionActual;
    var purlinCentersMaximum;

    // Output Elements
    var deflectionAllowedEl = $("#purlinCalcDeflectionAllowable");
    var deflectionActualEl = $("#purlinCalcDeflectionActual");
    var purlinCentersMaximumEl = $("#purlinCalcCentersMax");
    var warningBottom = $("#purlinCalcWarningBottom");
    var warningTop = $("#purlinCalcWarningTop");

    baySize = baySize < 1500 ? 1500 : baySize;
    baySize = baySize > 6000 ? 6000 : baySize;
    baySizeEl.val(baySize);
    purlinCalcPreset(baySize, 'no');

    purlinCentersActual = purlinCentersActual < 200 ? 200 : purlinCentersActual;
    purlinCentersActual = purlinCentersActual > 2000 ? 2000 : purlinCentersActual;
    purlinCentersActualEl.val(purlinCentersActual);

    if (baySize >= 1500 && purlinCentersActual >= 200) {
        if (region === "A") {
            if (terrainCategory === '2') {
                windSpeed = 40.95;
                windPressure = 0.68;
            } else if (terrainCategory === '2.5') {
                windSpeed = 39.15;
                windPressure = 0.62;
            } else { // TC3
                if (shielding === "Yes") {
                    windSpeed = 33.62;
                    windPressure = 0.46;
                } else {
                    windSpeed = 37.35;
                    windPressure = 0.57;
                }
            }
        } else if (region === "B") {
            if (terrainCategory === '2') {
                windSpeed = 51.87;
                windPressure = 0.76;
            } else if (terrainCategory === '2.5') {
                windSpeed = 49.59;
                windPressure = 0.69;
            } else { // TC3
                if (shielding === "Yes") {
                    windSpeed = 42.58;
                    windPressure = 0.51;
                } else {
                    windSpeed = 47.31;
                    windPressure = 0.63;
                }
            }
        } else { // region === "C"
            if (terrainCategory === '2') {
                windSpeed = 63.06;
                windPressure = 1.21;
            } else if (terrainCategory === '2.5') {
                windSpeed = 60.29;
                windPressure = 1.11;
            } else { // TC3
                if (shielding === "Yes") {
                    windSpeed = 51.77;
                    windPressure = 0.82;
                } else {
                    windSpeed = 57.52;
                    windPressure = 1.01;
                }
            }
        }
        ix = 0.117;
        if (topHat === "TH6160") {
            ix = 0.094;
        } else if (topHat === "TH6110") {
            ix = 0.157;
        } else if (topHat === "TH6112") {
            ix = 0.188;
        } else if (topHat === "TH6475") {
            ix = 0.087;
        } else if (topHat === "TH6410") {
            ix = 0.116;
        } else if (topHat === "TH6412") {
            ix = 0.143;
        } else if (topHat === "TH9675") {
            ix = 0.205;
        } else if (topHat === "TH9610") {
            ix = 0.273;
        } else if (topHat === "TH9612") {
            ix = 0.328;
        }

        var warningCount = 0;

        resultFixed = windSpeed.toFixed(2);

        result = baySize / 300;
        resultRounded = Math.round(result * 10) / 10;
        deflectionAllowed = resultRounded;
        resultFixed = resultRounded.toFixed(1);
        deflectionAllowedEl.val(resultFixed + " mm");

        result = 5 / 384;
        result *= windPressure;
        result *= purlinCentersActual / 1000;
        result *= Math.pow(baySize, 4);
        result /= 2 * Math.pow(10, 5) * ix * Math.pow(10, 6);
        resultRounded = Math.round(result * 10) / 10;
        deflectionActual = resultRounded;
        resultFixed = resultRounded.toFixed(1);
        deflectionActualEl.val(resultFixed + " mm");

        if (deflectionActual > deflectionAllowed) {
            deflectionActualEl.css('color', 'rgb(255,255,0)');
            deflectionActualEl.css('background-color', 'rgb(255,0,0)');
            deflectionActualEl.css('border-color', 'rgb(0,0,0)');
            deflectionActualEl.css('font-weight', 'bold');
            warningCount++;
        } else {
            deflectionActualEl.css('color', 'rgb(64, 64, 64)');
            deflectionActualEl.css('background-color', 'rgb(245, 245, 245)');
            deflectionActualEl.css('border-color', 'rgb(228, 228, 228)');
            deflectionActualEl.css('font-weight', 'normal');
        }

        result = deflectionAllowed;
        result *= 2 * Math.pow(10, 5) * ix * Math.pow(10, 6);
        result /= Math.pow(baySize, 4) * (5 / 384) * windPressure;
        result *= 1000;
        resultRounded = Math.round(result);
        purlinCentersMaximum = resultRounded;
        resultFixed = resultRounded.toFixed(0);
        purlinCentersMaximumEl.val(resultFixed + " mm");
        if (purlinCentersActual > purlinCentersMaximum) {
            purlinCentersMaximumEl.css('color', 'rgb(255,255,0)');
            purlinCentersMaximumEl.css('background-color', 'rgb(255,0,0)');
            purlinCentersMaximumEl.css('border-color', 'rgb(0,0,0)');
            purlinCentersMaximumEl.css('font-weight', 'bold');
            warningCount++;
        } else {
            purlinCentersMaximumEl.css('color', 'rgb(64, 64, 64)');
            purlinCentersMaximumEl.css('background-color', 'rgb(245, 245, 245)');
            purlinCentersMaximumEl.css('border-color', 'rgb(228, 228, 228)');
            purlinCentersMaximumEl.css('font-weight', 'normal');
        }

        if (warningCount > 0) {
            warningBottom.show();
            warningTop.show();
        } else {
            warningBottom.hide();
            warningTop.hide();
        }

    } else {
        deflectionAllowedEl.val("");
        deflectionActualEl.val("");
        deflectionActualEl.css('color', 'rgb(64, 64, 64)');
        deflectionActualEl.css('background-color', 'rgb(245, 245, 245)');
        deflectionActualEl.css('border-color', 'rgb(228, 228, 228)');
        deflectionActualEl.css('font-weight', 'normal');

        purlinCentersMaximumEl.val("");
        purlinCentersMaximumEl.css('color', 'rgb(64, 64, 64)');
        purlinCentersMaximumEl.css('background-color', 'rgb(245, 245, 245)');
        purlinCentersMaximumEl.css('border-color', 'rgb(228, 228, 228)');
        purlinCentersMaximumEl.css('font-weight', 'normal');

        warningBottom.hide();
        warningTop.hide();
    }
}


function toggleVisibility(elementId) {
    var element = $("#" + elementId);
    element.toggle();
}


function purlinResult() {
    var purlinStrength = $("#purlinStrength");
    var purlinDeflection = $("#purlinDeflection");
    var purlinResult = $("#purlinResult");
    var purlinResultHTML = $("#purlinResultHTML");
    var myHTML;
    if (purlinStrength.val() &&
        purlinDeflection.val()) {
        if ((purlinStrength.val() === 'topHat' || purlinStrength.val() === 'zed') &&
            purlinDeflection.val() === 'valid') {
            myHTML = '<i class="fe-icon-check-circle pr-2"></i>Recommended';
            purlinResultHTML
                .css('background-color', '#00FF00')
                .css('color', '#0000FF')
                .html(myHTML);

        } else if (purlinDeflection.val() === 'invalid') {
            myHTML = '<i class="fe-icon-alert-triangle pr-2"></i>DO NOT BUY';
            purlinResultHTML
                .css('background-color', '#FF0000')
                .css('color', '#FFFF00')
                .html(myHTML);

        } else {
            myHTML = '<i class="fe-icon-alert-triangle pr-2"></i>Caution';
            purlinResultHTML
                .css('background-color', '#FFA500')
                .css('color', '#FFFFFF')
                .html(myHTML);
        }
        purlinResult.show();
    }
}


function rafterResult() {
    var rafterStrength = $("#rafterStrength");
    var rafterDeflection = $("#rafterDeflection");
    var rafterResult = $("#rafterResult");
    var rafterResultHTML = $("#rafterResultHTML");
    var myHTML;
    if (rafterStrength.val() &&
        rafterDeflection.val()) {
        if (rafterStrength.val() === 'G450' &&
            rafterDeflection.val() === 'valid') {
            myHTML = '<i class="fe-icon-check-circle pr-2"></i>Recommended';
            rafterResultHTML
                .css('background-color', '#00FF00')
                .css('color', '#0000FF')
                .html(myHTML);

        } else if (rafterDeflection.val() === 'invalid') {
            myHTML = '<i class="fe-icon-alert-triangle pr-2"></i>DO NOT BUY';
            rafterResultHTML
                .css('background-color', '#FF0000')
                .css('color', '#FFFF00')
                .html(myHTML);

        } else {
            myHTML = '<i class="fe-icon-alert-triangle pr-2"></i>Not Recommended';
            rafterResultHTML
                .css('background-color', '#FFA500')
                .css('color', '#FFFFFF')
                .html(myHTML);
        }
        rafterResult.show();
    }
}


function restartTest() {
    window.open('shed-health-test.php', '_self');
}


function resultsPage() {
    var element;
    var elements;
    var failElement;

    elements = [];
    elements.push(["portalHiTensile", "structural", "checkbox"]);
    elements.push(["rafterDeflection", "structural", "checkbox"]);
    elements.push(["purlinHiTensile", "structural", "checkbox"]);
    elements.push(["purlinDeflection", "structural", "checkbox"]);
    elements.push(["purlinCenters", "structural", "checkbox"]);
    elements.push(["girtHiTensile", "structural", "checkbox"]);
    elements.push(["girtCenters", "structural", "checkbox"]);
    elements.push(["claddingRoofHiTensile", "cladding", "checkbox"]);
    elements.push(["claddingRoofGauge", "cladding", "checkbox"]);
    elements.push(["claddingRoofColour", "cladding", "dropdown"]);

    var structural = {
        "yes": 0,
        "no": 0,
        "count": 0
    }
    var cladding = {
        "yes": 0,
        "no": 0,
        "count": 0
    }

    $.each(elements, function (index, value) {
        element = $("#" + value[0]);
        if (value[2] === "dropdown") {
            if (value[1] === "cladding") {
                cladding.count++;
                if (element.val() !== null) {
                    if (element.val() === "fail") {
                        cladding.no++;
                    } else {
                        cladding.yes++;
                    }
                }
            }
        } else { // Checkbox
            failElement = $("#" + value[0] + "Fail");
            if (value[1] === "cladding") {
                cladding.count++;
                if (element.prop('checked')) {
                    cladding.yes++;
                } else if (failElement.prop('checked')) {
                    cladding.no++;
                }
            } else { // structural
                structural.count++;
                if (element.prop('checked')) {
                    structural.yes++;
                } else if (failElement.prop('checked')) {
                    structural.no++;
                }
            }
        }

    });

    if (cladding.yes + cladding.no !== cladding.count ||
        structural.yes + structural.no !== structural.count) { // Not all questions answered
        $("#resultSuccess").hide();
        $("#resultFailureStructural").hide();
        $("#resultFailureCladding").hide();
        $("#resultIncomplete").show();
    } else {
        if (cladding.yes === cladding.count && structural.yes === structural.count) {
            $("#resultSuccess").show();
            $("#resultFailureStructural").hide();
            $("#resultFailureCladding").hide();
            $("#resultIncomplete").hide();
        } else if (structural.yes !== structural.count) { // Structurally BAD
            if (fails.deflection > 0) {
                $("#resultFailureStructuralDeflection").show();
            } else {
                $("#resultFailureStructuralDeflection").hide();
            }
            if (fails.structuralGrade > 0) {
                $("#resultFailureStructuralGrade").show();
            } else {
                $("#resultFailureStructuralGrade").hide();
            }
            if (fails.centers > 0) {
                $("#resultFailureStructuralCenters").show();
            } else {
                $("#resultFailureStructuralCenters").hide();
            }
            $("#resultSuccess").hide();
            $("#resultFailureStructural").show();
            $("#resultFailureCladding").hide();
            $("#resultIncomplete").hide();
        } else { // Cladding BAD
            $("#resultSuccess").hide();
            $("#resultFailureStructural").hide();
            $("#resultFailureCladding").show();
            $("#resultIncomplete").hide();
        }
    }
}


function scrollTo(scrollToId) {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#" + scrollToId).offset().top -10
    }, 1000);
}


function updateTabs() {

    var step3Tab = $("#step3Tab");
    var step4Tab = $("#step4Tab");
    var step5Tab = $("#step5Tab");
    var step6Tab = $("#step6Tab");
    var questions;
    var questionsAnswered;

    questionsAnswered = true;
    questions = ['portalHiTensile', 'rafterDeflection'];
    $.each(questions, function (index, question) {
        if (!$("#" + question).prop('checked') && !$("#" + question + "Fail").prop('checked')) {
            questionsAnswered = false;
            return false;
        }
    });

    if (questionsAnswered) {
        step3Tab.css('cursor', 'pointer').css('pointer-events', 'auto').attr('onclick', 'displayStep(3);').removeClass('disabled-link');
        questionsAnswered = true;
        questions = ['purlinHiTensile', 'purlinDeflection', 'purlinCenters'];
        $.each(questions, function (index, question) {
            if (!$("#" + question).prop('checked') && !$("#" + question + "Fail").prop('checked')) {
                questionsAnswered = false;
                return false;
            }
        });

        if (questionsAnswered) {
            step4Tab.css('cursor', 'pointer').css('pointer-events', 'auto').attr('onclick', 'displayStep(4);').removeClass('disabled-link');
            questionsAnswered = true;
            questions = ['girtHiTensile', 'girtCenters'];
            $.each(questions, function (index, question) {
                if (!$("#" + question).prop('checked') && !$("#" + question + "Fail").prop('checked')) {
                    questionsAnswered = false;
                    return false;
                }
            });

            if (questionsAnswered) {
                step5Tab.css('cursor', 'pointer').css('pointer-events', 'auto').attr('onclick', 'displayStep(5);').removeClass('disabled-link');
                questionsAnswered = true;
                questions = ['claddingRoofHiTensile', 'claddingRoofGauge', 'claddingRoofColour'];
                $.each(questions, function (index, question) {
                    if (question === 'claddingRoofColour') {
                        if ($("#" + question).val() === null) {
                            questionsAnswered = false;
                            return false;
                        }
                    } else if (!$("#" + question).prop('checked') && !$("#" + question + "Fail").prop('checked')) {
                        questionsAnswered = false;
                        return false;
                    }
                });
                if (questionsAnswered) {
                    step6Tab.css('cursor', 'pointer').css('pointer-events', 'auto').attr('onclick', 'displayStep(6);').removeClass('disabled-link');
                }
            }
        }
    }
}


function validatePurlinShielding() {
    var shieldingEl = $("#purlinCalcShielding");
    var shieldingOption = $("#purlinCalcShielding option[value='Yes']");
    var terrainCategoryEl = $("#purlinCalcTerrain");
    if (shieldingEl.val() === 'Yes') {
        if (terrainCategoryEl.val() !== "3") {
            shieldingEl.val("No");
        }
    }
    if (terrainCategoryEl.val() === "3") {
        shieldingOption.prop("disabled", false);
    } else {
        shieldingOption.prop("disabled", "disabled");
    }
}




